import React from 'react';
import icon from '../assets/images/icons/elevator.svg';

const ElevatorPitch = () => {
  return (
    <div className="ElevatorPitch">
      <div className="ElevatorPitch__Wrapper">
        <div className="ElevatorPitch__Icon">
          <img src={icon} alt="Icon" />
        </div>
        <div className="ElevatorPitch__Text">
          We created Rig to provide you with a tool to manage your entire rig portfolio in one place, allowing everyone in your company to view the rig schedule at a glance.
<br/>
<br/>
          <a href="https://agr-software.com/#contact_us">Contact us for more information</a>
        </div>
      </div>
    </div>
  );
};

export default ElevatorPitch;



// WEBPACK FOOTER //
// ./src/components/ElevatorPitch.js